import { useFeatureValue } from '@growthbook/growthbook-react'

import { FEATURE_FLAGS } from '~shared/constants'
import { BannerLevel } from '~shared/types'

import { useAdminBanner } from './hooks/useAdminBanner'
import { AppBanner } from './AppBanner'

type AdminBannerFlag = { text: string; level: BannerLevel }

const ADMIN_BANNER_FLAG_DEFAULT: AdminBannerFlag = { text: '', level: 'info' }

export const AdminBanner = () => {
  const gbBanner = useFeatureValue<AdminBannerFlag>(
    FEATURE_FLAGS.ADMIN_BANNER,
    ADMIN_BANNER_FLAG_DEFAULT,
  )
  const { data } = useAdminBanner()

  if (gbBanner.text) {
    return <AppBanner text={gbBanner.text} level={gbBanner.level} />
  }
  return data ? <AppBanner text={data.text} level={data.level} /> : null
}
